
import React from "react";
import { Check } from "lucide-react";
import ValueProposition from "@/components/ValueProposition";

const FamilyMediationSection = () => {
  return (
    <ValueProposition
      title="Mediation für finanzielle Harmonie in Beziehungen"
      description="Finanzielle Themen sind in Partnerschaften und Familien oft eine Quelle für Konflikte. Unterschiedliche Einstellungen zu Risiko, Sparen oder Ausgaben können zu Spannungen führen. Als neutraler Mediator helfe ich, diese Unterschiede in produktive Gespräche zu verwandeln und gemeinsame Lösungen zu finden, die alle Beteiligten respektieren."
      image="/lovable-uploads/ae21d5f3-3003-4829-a404-69e06735a30d.png"
      imageAlt="Mediationsgespräch mit aufmerksamem Zuhören - Finanzielle Konflikte konstruktiv lösen"
      backgroundColor="bg-joerg-50"
      imageOverlay={true}
      overlayColor="bg-joerg-600"
      overlayOpacity="opacity-5"
    >
      <div className="mt-2 space-y-3">
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600 text-left">
            Transformation finanzieller Konflikte in konstruktive Lösungen
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600 text-left">
            Aufbau eines gemeinsamen finanziellen Verständnisses trotz unterschiedlicher Perspektiven
          </span>
        </div>
        <div className="flex items-start gap-3">
          <Check className="h-5 w-5 text-primary flex-shrink-0" />
          <span className="text-joerg-600 text-left">
            Einbeziehung von Jugendlichen in finanzielle Bildung und Familienentscheidungen
          </span>
        </div>
      </div>
    </ValueProposition>
  );
};

export default FamilyMediationSection;
